// extracted by mini-css-extract-plugin
export var text = "_bg-0";